import { Button, Modal } from "react-bootstrap";
import { BadgeStatus } from "../../badges/statusBadge";
import DateFormat from "./../../format/DateFormat";
import { useState } from "react";
import ComponentStatusScreen from "../../../layout/components/mercado-pago/components/ComponentStatusScreen";
import ComponentBricks from "../../../layout/components/mercado-pago/components/ComponentBricks";
import DecimalNumberCents from "../../format/DecimalNumberCents";

type ViewChargeModalProps = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setDashboardUpdate?: React.Dispatch<React.SetStateAction<boolean>>;
  handleClose: () => void;
  item?: any;
};

const ViewChargeModal: React.FC<ViewChargeModalProps> = ({
  showModal,
  item,
  setShowModal,
  handleClose,
  setDashboardUpdate,
}) => {
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [changeShowPaymentModal, setChangeShowPaymentModal] = useState(false);
  const errorOrRefunded = [
    "rejected",
    "cancelled",
    "refunded",
    "charged_back",
    "pending_waiting_transfer",
  ];

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleClose}
        centered={true}
        contentClassName="me-1"
      >
        <Modal.Header className="d-flex align-items-center" closeButton>
          <Modal.Title>Detalhes da cobrança</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {item ? (
            <div className="row">
              <div className="col-12 col-md-6 d-flex flex-column">
                <label className="fw-bold">Contrato:</label>
                <span>{item?.contract?.description}</span>
              </div>
              <div className="col-12 col-md-6 d-flex flex-column">
                <label className="fw-bold">Nome do Plano:</label>
                <span>{item?.contract?.plan_name}</span>
              </div>
              <div className="separator my-5"></div>
              <div className="col-12 col-md-6 d-flex flex-column">
                <label className="fw-bold">Cobrança:</label>
                <span>{item?._id}</span>
              </div>
              <div className="col-12 col-md-6 d-flex flex-column">
                <label className="fw-bold">Status da Cobrança:</label>
                <BadgeStatus
                  description={item?.status?.description}
                  className="mt-2"
                />
              </div>
              <div className="separator my-5"></div>
              <div className="col-12 col-md-6 d-flex flex-column">
                <label className="fw-bold">Data Vencimento:</label>
                <span>
                  <DateFormat date={item?.expiration_date ?? ""}></DateFormat>
                </span>
              </div>
              <div className="col-12 col-md-6 d-flex flex-column">
                <label className="fw-bold">Data do Pagamento:</label>
                <span>
                  <DateFormat date={item?.payment_date}></DateFormat>
                </span>
              </div>
              <div className="separator my-5"></div>
              <div className="col-12 col-md-6 d-flex flex-column">
                <label className="fw-bold">Valor da Cobrança:</label>
                <span>
                  <DecimalNumberCents
                    value={item?.value}
                    prefix="R$ "
                  ></DecimalNumberCents>
                </span>
              </div>
              <div className="col-12 col-md-6 d-flex flex-column">
                <label className="fw-bold">Valor Pago:</label>
                <DecimalNumberCents
                  value={item?.payment_value}
                  prefix="R$ "
                ></DecimalNumberCents>
              </div>
            </div>
          ) : (
            showModal && (
              <div className="row d-flex justify-content-center align-items-center">
                <span
                  style={{ width: "50px", height: "50px" }}
                  className="spinner-border spinner-border-sm align-middle ms-2"
                ></span>
              </div>
            )
          )}
        </Modal.Body>

        <Modal.Footer>
          {item?.notifications && item?.notifications.length > 0 ? (
            <Button
              className="btn btn-primary"
              onClick={() => {
                setShowPaymentModal(true);
                handleClose();
              }}
            >
              Verificar Status
            </Button>
          ) : (
            <Button
              className="btn btn-success"
              onClick={() => {
                setShowPaymentModal(true);
                handleClose();
              }}
            >
              Realizar Pagamento
            </Button>
          )}

          <Button variant="secondary" onClick={handleClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={changeShowPaymentModal}
        centered={true}
        onHide={() => setChangeShowPaymentModal(false)}
      >
        <Modal.Body>
          <ComponentBricks
            itemId={item?._id}
            itemValue={item?.value}
            setDashboardUpdate={setDashboardUpdate}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setChangeShowPaymentModal(false)}
          >
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
        centered={true}
      >
        <Modal.Body>
          {item?.notifications && item?.notifications.length > 0 ? (
            <ComponentStatusScreen
              payment_key={
                item?.notifications?.[item?.notifications?.length - 1]
                  ?.payment_key
              }
            />
          ) : (
            <ComponentBricks
              itemId={item?._id}
              itemValue={item?.value}
              setDashboardUpdate={setDashboardUpdate}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          {errorOrRefunded.includes(
            item?.notifications?.[item?.notifications?.length - 1]
              ?.status_detail
          ) ? (
            <Button
              className="btn btn-primary"
              onClick={() => {
                setShowPaymentModal(false);
                setChangeShowPaymentModal(true);
              }}
            >
              Trocar método Pagamento
            </Button>
          ) : null}

          <Button
            variant="secondary"
            onClick={() => setShowPaymentModal(false)}
          >
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewChargeModal;
